import "./ShoppingCart.css";

import SvgCart from "../../assets/images/cart.svg";
import { uuidv4 } from "../../wwtools";
import { useData } from "../../consts";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";

const shoppingCartId = `shoppingcart-${uuidv4()}`;

export const AddToCart = props=>{
    const pdt=props.pdt;
    const {register, getValues, setValue} = useForm();
    const qtyName = "quantity";
    const {onChange, ...rest} = register(qtyName);
    const {cart, setCart} = useData();

    const [,forceUpdate]=useState();

    // init value
    useEffect(_=>{
        setValue(qtyName, props.qty);
    }, [props.qty]) //[important] use props.qty to trigger refresh

    useEffect(_=>{
        if(props.actionButton==="remove"){
            const newCart = {...cart};
            newCart[pdt.__id].qty = getValues()[qtyName];

            setCart(newCart);
        }
    }, [getValues()[qtyName]]);

    return <form className="input-group p-3 .flex-grow-0 .d-inline-flex"
                
        onSubmit={evt=>{
            evt.stopPropagation();
            evt.preventDefault();
        }}
    >
        <span className="input-group-text">quantity</span>
        <input
            type="text"
            className="form-control"
            // placeholder="Recipient's username"
            aria-label="quantity"
            style={{"maxWidth":"5em", "minWidth":"5em"}}
            onChange={evt=>{
                const out = onChange(evt);
                forceUpdate(Math.random());
            }}
            {...rest}
        />
        <button className="btn btn-outline-secondary"
            type="button"
            onClick={evt=>{
                const newValue = Math.max(parseFloat(getValues()[qtyName]||0)-1,0);
                setValue(qtyName, newValue);
                forceUpdate(Math.random());
            }}
        >-</button>
        <button className="btn btn-outline-secondary"
            type="button"
            onClick={evt=>{
                const newValue = parseFloat(getValues()[qtyName]||0)+1;
                setValue(qtyName, newValue);
                forceUpdate(Math.random());
            }}
        >+</button>
        {(props.actionButton==="addToCart")&&<>
            <button className="btn btn-outline-secondary"
                type="button"
                onClick={evt=>{
                    const newCart = {...cart};
                    const qty = parseFloat(getValues(qtyName));
                    newCart[pdt.__id] = newCart[pdt.__id] || {pdt: pdt, qty:0};
                    newCart[pdt.__id].qty += qty;

                    setCart(newCart);
                }}
            >add to cart</button>
        
        </>}

        {(props.actionButton==="remove")&&<>
            <button className="btn btn-outline-secondary"
                type="button"

                onClick={evt=>{
                    const newCart = {...cart};
                    delete newCart[pdt.__id];

                    setCart(newCart);
                }}
            >remove</button>
        </>}
    </form>;
}

export const CartBtn = props=><>
    <img className="" src={SvgCart} style={{"width":"1.5em"}} role="button" href={`#${shoppingCartId}`}  aria-expanded="false" data-bs-toggle="offcanvas" aria-controls="offcanvasExample"/>
    <a className="nav-link pull-left"
        role="button"
        href={`${shoppingCartId}`}
        aria-expanded="false"
        data-bs-toggle="offcanvas"
        data-bs-target={`#${shoppingCartId}`}
        aria-controls={shoppingCartId}
//         <button className="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
//         Button with data-bs-target
//         </button>
    >Cart</a>
</>;

export const CartItem = props=>{
    const pdt = props.pdt;
    const qty = props.qty;
    const unitPrice = props.unitPrice || 999;
    const unit = props.unit || 'piece';
    const refQty = useRef();

    const {cart, setCart} = useData();

    const [itemTotal, setItemTotal] = useState(0);
    useEffect(_=>{
        setItemTotal(parseFloat(unitPrice) * parseFloat(props.qty));
    }, [pdt, qty, unitPrice, cart]);

    return <div className="card">
        <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
                {/* <img src="https://via.placeholder.com/100" alt="Product Image" className="img-thumbnail me-3" /> */}
                <div className="me-3" style={{"minWidth":"100px",
                    "minHeight":"100px", "width":"100px", "height":"100px",
                    "backgroundPosition": "center center",
                    "backgroundSize":"cover", 
                    "background":`darkbrown url(${"http://127.0.0.1:5000/static/uploads/1736498500807596100-1734449610245985100-IMG_20241217_102012.jpg"})`}}>

                </div>
                <div>
                    <h5 className="mb-0">{pdt.name}</h5> ({pdt.sn})
                    <p className="mb-0 text-muted">Category: {""}</p>
                    <p className="mb-0 text-muted">Unit price: ${unitPrice}</p>
                </div>
            </div>
            <div className="d-flex align-items-center">
                <AddToCart 
                    pdt={pdt}
                    qty={qty}
                    actionButton={"remove"}
                />
                {/* <button className="btn btn-outline-secondary btn-sm">-</button>
                <input type="text"
                    className="form-control form-control-sm mx-2 text-center"
                    style={{"width": "50px", "width": "50px"}}
                    value={qty}
                    ref = {refQty}
                />
                <button className="btn btn-outline-secondary btn-sm">+</button>
                <h5 className="mb-0 ms-4">${parseFloat(itemTotal).toFixed(2)}</h5>
                <button className="btn btn-danger btn-sm ms-3">Remove</button> */}
            </div>
            </div>
        </div>
    </div>;
}

export const CartBody = props=>{
    const {cart, setCart} = useData();

    const [subtotal, setSubtotal] = useState(0);
    const [shippingFee, setShippingFee] = useState(0);
    const [tax, setTax] = useState(0);
    const [taxRate, setTaxRate] = useState(0.17);
    const [total, setTotal] = useState(0);

    useEffect(_=>{
        let _subTotal = 0;
        let _shippingFee = 5;
        let _taxRate = taxRate;
        Object.values(cart||{}).map(cartItem=>{
            _subTotal += parseFloat(cartItem.qty || 0) * (cartItem.onShelfPrice || 999);
        })
        _shippingFee = _subTotal?_shippingFee:0;
        const _tax = (_subTotal + _shippingFee)  * _taxRate;
        const _total = _subTotal + _shippingFee + _tax;

        setSubtotal(_subTotal);
        setShippingFee(_shippingFee);
        setTax(_tax);
        setTotal( _total);

    }, [cart]);

    return <>

        <div 
            className="offcanvas offcanvas-end custom-offcanvas"
            tabIndex="-1"
            id={shoppingCartId}
            aria-labelledby={shoppingCartId+"-Label"}
        >
            <div className="offcanvas-header">
                <h1 className="offcanvas-title"
                    id={shoppingCartId+"-Label"}
                >
                        Shopping Cart
                </h1>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></button>
            </div>
            <div className="offcanvas-body px-5">
                <div className="container">
                    {/* <h1 className="text-center mb-4">Shopping Cart</h1> */}
                    <div className="row">
                        <div className="col">
                            {/* <!-- Product List --> */}
                            <div className="row">

                                {Object.keys(cart||{}).map((pdtId, itemIdx)=>{
                                    const pdtData = cart[pdtId] || {};
                                    const pdt=pdtData.pdt || {};
                                    return <CartItem
                                        key={`${pdtId}-${itemIdx}`}
                                        pdt={pdt}
                                        qty={pdtData.qty}
                                    />;
                                })}

                            </div>
                        </div>

                        {/* <!-- Order Summary --> */}
                        <div className="col my-3">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Order Summary</h5>
                                    <ul className="list-group list-group-flush">
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        Subtotal
                                        <span>${parseFloat(subtotal).toFixed(2)}</span>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        Shipping
                                        <span>${parseFloat(shippingFee).toFixed(2)}</span>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        Tax ({parseFloat(taxRate*100).toFixed(2)}%)
                                        <span>${parseFloat(tax).toFixed(2)}</span>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center fw-bold">
                                        Total
                                        <span>${parseFloat(total).toFixed(2)}</span>
                                    </li>
                                    </ul>
                                    <button className="btn btn-primary w-100 mt-3">Checkout</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>




            </div>
        </div>    

</>};

export default function ShoppingCart(props){






    return <>
        <CartBtn />
        <CartBody />
    </>

};

